import { JSX } from 'react'

import { LoginForm } from '~/components/LoginForm'
import {
  Dialog,
  SplitsDialogContent,
} from '~/components/component-library/Dialog'
import { useAuth } from '~/context/AuthProvider'
import { useIsStandalone } from '~/hooks/useIsStandalone'

export const LoginModal = (): JSX.Element => {
  const { loginModalState: isLoginModalOpen, setLoginModalState } = useAuth()
  const isStandalone = useIsStandalone()

  return (
    <Dialog
      open={isLoginModalOpen}
      onOpenChange={(open) => setLoginModalState(open)}
    >
      <SplitsDialogContent
        id="signin"
        title={
          isStandalone ? 'Sign in to Splits' : 'Sign in or create an account'
        }
        variant="info"
      >
        <LoginForm />
      </SplitsDialogContent>
    </Dialog>
  )
}
